/* Native details remains usable without this reversible height animation. */
if (!customElements.get('objectiv-product-disclosure')) {
  customElements.define('objectiv-product-disclosure', class extends HTMLElement {
    connectedCallback() {
      if (this.lifetime) return;
      this.lifetime = new AbortController();
      const options = {signal: this.lifetime.signal};
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.body = this.querySelector('.obj-standalone-product__details-body');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.expanded = this.details.open;
      this.summary.setAttribute('aria-expanded', String(this.expanded));
      this.summary.addEventListener('click', event => { event.preventDefault(); this.toggle(); }, options);
      addEventListener('resize', () => this.settle(), options);
      this.motion.addEventListener('change', () => this.settle(), options);
    }

    toggle() {
      const start = this.details.getBoundingClientRect().height;
      this.animation?.cancel(); this.fade?.cancel();
      this.expanded = !this.expanded;
      this.details.open = true;
      this.details.dataset.expanded = String(this.expanded);
      this.summary.setAttribute('aria-expanded', String(this.expanded));
      this.body.inert = !this.expanded;
      const end = this.expanded ? this.details.getBoundingClientRect().height : this.summary.offsetHeight;
      if (this.motion.matches || !this.details.animate) { this.settle(); return; }
      this.details.style.overflow = 'hidden';
      this.animation = this.details.animate({height:[`${start}px`, `${end}px`]}, {duration:260,easing:'cubic-bezier(.2,.7,.2,1)'});
      this.fade = this.body.animate({opacity:this.expanded?[0,1]:[1,0],transform:this.expanded?['translateY(-4px)','none']:['none','translateY(-4px)']}, {duration:200,easing:'ease'});
      this.animation.onfinish = () => this.settle();
    }

    settle() {
      this.animation?.cancel(); this.fade?.cancel();
      this.animation = this.fade = null;
      this.details.open = this.expanded;
      this.details.style.removeProperty('overflow');
      this.body.inert = !this.expanded;
    }

    disconnectedCallback() { this.settle(); this.lifetime?.abort(); this.lifetime = null; }
  });
}
